<div class="example-pizza-party">
    <div class="left">
        <!-- <mat-icon>success</mat-icon>
          <mat-icon>error_outline</mat-icon> -->
        <span *ngIf="data.action == 'success'" class="material-icons">
            check_circle
        </span>
        <span *ngIf="data.action == 'warning'" class="material-icons warning"> warning </span>
        <mat-icon *ngIf="data.action == 'error' || data.action == 'info'" class="material-icons"
            style="font-size: 16px;width:18px;height:20px;padding-top: 0px;margin-top: -2px;"><img
                src="../../../assets/icons/info.svg" /> </mat-icon>
    </div>
    <div class="message" [ngStyle]="{color: data.action == 'warning'? '#000000DE' : '#FFFFFF'}">{{ data.message }}</div>

    <div class="right" *ngIf="data.hasCloseBtn">
        <button class="changeClass" (click)="closeAlert()" mat-icon-button class="example-icon"
            aria-label="Example icon-button with share icon">
            <!-- <mat-icon style="width: 42px;height: 42px;font-size: 42px;color: #9ca2a5;margin-right: 8px;"> account_circle
        </mat-icon> -->
            <mat-icon style="font-size: 24px; color: #fff !important" class="changeClass">close</mat-icon>
        </button>
    </div>
</div>
<div class="content" *ngIf="content" [ngStyle]="{color: data.action == 'warning'? '#000000DE' : '#FFFFFF'}">
        {{content}}
</div>
